import React, { useState, useEffect } from "react";
import UISectionHeading from "../Common/UISectionHeading/UISectionHeading";
import UiButton from "../Common/UiButton/UiButton";
import { Col, Row } from "react-bootstrap";
import TextInput from "../Common/UITextInput/TextInput";
import {
  Form,
  message,
  Checkbox,
  Select,
  Tag,
  DatePicker,
  notification,
} from "antd";
import moment from "moment";
import UiDropDown from "../Common/UiDropDown/UiDropDown";
import "../YourFirmDetails/yourFirmDetails.css";
import useForm from "../../common/hooks/useForm";
import { getTeamsDirectDetail } from "../../redux/TeamDetailsMaster/action";
import { connect } from "react-redux";
import { saveTeamsDirectorDetailsAll } from "../../redux/TeamsDirectorPartnerDetails/action";
import { useNavigate } from "react-router-dom";
import { getTeamSideBarDetails } from "../../redux/SideBarTeams/action";
import useSession from "../CustomLogout/useSession";

const TeamDetailsDirectorPartnerDetails = (props) => {
  const handleSessionExpired = useSession();

  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const Id = sessionStorage.getItem("cetFirmId");
  let navigate = useNavigate();
  let imgIconShow;
  let personQualificationget;
  let QualicationData;
  let personSalutationData;

  const { saveAllIndication, setHandleGetTeamDirector } = props;

  const { state, onChangeTextHandler, setState } = useForm();
  const [btnDisable, setBtnDisable] = useState(false);
  const [showText, setShowText] = useState(false);

  const [dateOfBirth, setDateOfBirth] = useState();

  const [partnerFirmMSMEFlagCheck, setPartnerFirmMSMEFlagCheck] =
    useState(false);

  // useEffect(() => {
  //   props.getData({
  //     accessToken: props.state.accessToken.access_token,
  //     parnterFirmID: props.firmId,
  //   });
  // }, []);

  useEffect(() => {
    if (saveAllIndication) {
      form.submit();
    }
  }, [saveAllIndication]);

  const personSalutationget = {
    label: props.data?.teamsDirectDataList?.dto?.personSalutation?.name,
    value: props.data?.teamsDirectDataList?.dto?.personSalutation?.id,
  };
  if (props.personId !== undefined) {
    personQualificationget = {
      label: props.data?.teamsDirectDataList?.dto?.personQualification?.name,
      value: props.data?.teamsDirectDataList?.dto?.personQualification?.id,
    };
  }
  if (props.personId !== undefined) {
    personQualificationget = {
      label: props.data?.teamsDirectDataList?.dto?.personSalutation?.name,
      value: props.data?.teamsDirectDataList?.dto?.personSalutation?.id,
    };
  }

  const hideSection = () => {
    setShowText(!showText);
  };

  useEffect(() => {
    if (props.personId == undefined) {
      setState({
        personFullName: "",
        personDateofBirth: "",

        relativeOfAFSLEmployeeFlag: "",
        relatedAFSLEmployeeName: "",
        personQualification: "",
        personSalutation: "",
      });
      setDateOfBirth();
      form.setFieldsValue({
        personFullName: "",
        salutation: "",
        directorsQualication: "",
        personDateofBirth: "",
      });
      setShowText(false);
      setPartnerFirmMSMEFlagCheck(false);
    }
    if (props.data && props?.personId !== undefined) {
      setState({
        ...state,
        personFullName: props.data?.teamsDirectDataList?.dto?.personFullName,
        // personDateofBirth:
        //   props.data?.teamsDirectDataList?.dto?.personDateofBirth,
        relativeOfAFSLEmployeeFlag: partnerFirmMSMEFlagCheck,
        relatedAFSLEmployeeName:
          props.data?.teamsDirectDataList?.dto?.relatedAFSLEmployeeName,
        personQualification: {
          label:
            props.data?.teamsDirectDataList?.dto?.personQualification?.name,
          value: props.data?.teamsDirectDataList?.dto?.personQualification?.id,
        },
        personSalutation: personSalutationget,
      });
      setPartnerFirmMSMEFlagCheck(
        props.data?.teamsDirectDataList?.dto?.relativeOfAFSLEmployeeFlag
      );

      setDateOfBirth(
        props.data?.teamsDirectDataList?.dto?.personDateofBirth
          ? moment(
              Number(props.data?.teamsDirectDataList?.dto?.personDateofBirth)
            )
          : undefined
      );

      form.setFieldsValue({
        personFullName: props.data?.teamsDirectDataList?.dto?.personFullName,
        directorsQualication: {
          label:
            props.data?.teamsDirectDataList?.dto?.personQualification?.name,
          value: props.data?.teamsDirectDataList?.dto?.personQualification?.id,
        },
        salutation: {
          label: props.data?.teamsDirectDataList?.dto?.personSalutation?.name,
          value: props.data?.teamsDirectDataList?.dto?.personSalutation?.id,
        },
        relatedAFSLEmployeeName:
          props.data?.teamsDirectDataList?.dto?.relatedAFSLEmployeeName ?? "",
      });
    }
    if (
      props?.personId !== undefined &&
      props.data?.teamsDirectDataList?.dto?.relativeOfAFSLEmployeeFlag == true
    ) {
      setShowText(true);
    }

    QualicationData =
      props.qualificationList?.length > 0
        ? props.qualificationList.map((el) => {
            return {
              label: el.academicDecipline,
              value: el.academicId,
            };
          })
        : [];
  }, [props.data?.teamsDirectDataList?.dto, props.personId]);

  QualicationData =
    props.qualificationList?.length > 0
      ? props.qualificationList.map((el) => {
          return {
            label: el.academicDecipline,
            value: el.academicId,
          };
        })
      : [];

  personSalutationData =
    props.salutationList?.length > 0
      ? props.salutationList.map((el) => {
          return {
            label: el.value,
            value: el.serialId,
          };
        })
      : [];

  const handleNoOfChnage = (val) => {
    setState({
      ...state,
      personQualification: {
        id: val.value,
        name: val.label,
      },
    });
  };

  const handleSalutationOfChnage = (val) => {
    setState({
      ...state,
      personSalutation: {
        id: val.value,
        name: val.label,
      },
    });
  };

  // const datasend =
  //   state.personQualification.length > 0
  //     ? state.personQualification.map((el) => {
  //         return {
  //           id: el.value,
  //           name: el.label,
  //         };
  //       })
  //     : [];

  const [savepartnerPersonalId, setsavepartnerPersonalId] = useState("");

  const handleChange = (data) => {
    const qualificationdataSub = {
      id: state.personQualification.value,
      name: state.personQualification.label,
    };
    const personSalutationSubData = {
      id: state.personSalutation.value,
      name: state.personSalutation.label,
    };
    setBtnDisable(true);
    let teamsDetailsData = {
      partnerPersonId: props.personId,
      personFullName: state.personFullName?.trim(),
      // personDateofBirth: dateOfBirth
      //   ? moment(dateOfBirth).format("DD-MM-YYYY")
      //   : "",
      personDateofBirth: dateOfBirth ? moment(dateOfBirth).format("x") : "",
      relativeOfAFSLEmployeeFlag: partnerFirmMSMEFlagCheck,
      relatedAFSLEmployeeName: state.relatedAFSLEmployeeName?.trim(),
      personQualification: {
        id: data.directorsQualication.value,
        name: data.directorsQualication.label,
      },
      personSalutation: {
        id: data.salutation.value,
        name: data.salutation.label,
      },
    };

    if (saveAllIndication) {
      setHandleGetTeamDirector(teamsDetailsData);
    } else {
      props
        .saveTeamsDirectorDetailsAll({
          values: teamsDetailsData,
          access_token: props.access_token,
          partnerFirmId: props.firmId || Id,
        })

        .then((res) => {
          setBtnDisable(false);
          if (res && res?.status === 200) {
            message.success("Saved");
            setsavepartnerPersonalId(res?.data.PARTNER_TEAM_PERSON_ID);
            navigate(`/PartnerDashBoard/teamdetails`, {
              state: {
                id: props?.firmId || Id,
                teamId: res?.data?.PARTNER_TEAM_PERSON_ID,
              },
            });
            props
              .getTeamsData({
                accessToken: props.access_token,
                partnerFirmID: props.firmId || Id,
              })
              .then((res) => {
                if (res?.data?.error || res?.message) {
                  const errorCode =
                    res?.data?.error?.errorCode || res?.errorCode;
                  const errorMessage =
                    res?.data?.error?.message || res?.message;

                  if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                    handleSessionExpired();
                  } else {
                    notification.error({
                      description: errorMessage,
                      duration: 5,
                      placement: "top",
                    });
                  }
                }
              });
          }
          if (res?.response?.data?.error || res?.message) {
            const errorCode =
              res?.response?.data?.error?.errorCode || res?.errorCode;
            const errorMessage =
              res?.response?.data?.error?.message || res?.message;

            if (
              errorCode === "403" &&
              res?.data?.response?.error?.logoutStatus
            ) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    }
  };

  function onDobChange(date) {
    setDateOfBirth(date);
  }

  return (
    <div>
      <Form
        autoComplete="off"
        name="teamDetailsDirectorPartnerDetails"
        form={form}
        onFinish={handleChange}
        initialValues={{
          personQualificationget: personQualificationget,
          personSalutationget: personSalutationget,
        }}
      >
        <div className="inner-content">
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="content-Section">
              <Col md={6} className="leftsidecontent">
                <div className="subheading">
                  <UISectionHeading secHeading="Director / Partner Details" />
                </div>
              </Col>

              <Col md={6} className="right-field-section">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={3} className="DirectorNAme-sec">
                      <FormItem
                        name="salutation"
                        label="Salutation"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Enter Salutation",
                          },
                        ]}
                      >
                        <UiDropDown
                          onChange={handleSalutationOfChnage}
                          data={personSalutationData}
                        />
                      </FormItem>
                    </Col>
                    <Col md={9}>
                      <FormItem
                        name="personFullName"
                        label="Name of Director/Partner"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Name of Director/Partner",
                          },
                        ]}
                      >
                        <TextInput
                          maxLength={50}
                          name="personFullName"
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          type="text"
                          vale={state.personFullName}
                          onChange={onChangeTextHandler}
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={5} className="mob-sec-dtb">
                      <FormItem
                        label="Date of Birth (18+)"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "",
                          },
                        ]}
                      >
                        {/* <TextInput
                          name="personDateofBirth"
                          onChange={onChangeTextHandler}
                          // date of birth only allow 18+
                          disabledDate={(current) => {
                            return (
                              current.valueOf() >
                              moment().subtract(18, "year").valueOf()
                            );
                          }}
                          value={state.personDateofBirth}
                          type="date"
                        /> */}
                        <DatePicker
                          // name="personDateofBirth"
                          className="text-input-normal"
                          onChange={onDobChange}
                          value={dateOfBirth}
                          showTime={false}
                          size="middle"
                          disabledDate={(current) => {
                            return (
                              current.valueOf() >
                              moment().subtract(18, "year").valueOf()
                            );
                          }}
                          format="DD-MM-YYYY"
                          style={{
                            width: "90%",
                          }}
                        />
                      </FormItem>
                    </Col>
                    <Col md={5} className="mob-sec-qu">
                      <FormItem
                        name="directorsQualication"
                        label="Qualification"
                        colon={false}
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Qualifications",
                          },
                        ]}
                      >
                        <UiDropDown
                          onChange={handleNoOfChnage}
                          data={QualicationData}
                        />
                      </FormItem>
                    </Col>
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={12} className="checked-dark new-datacheck">
                      <FormItem
                        name="noOfEmployees"
                        label="Related to an Avanse Employee"
                        colon={false}
                        rules={[
                          {
                            required: false,
                            message: "Please Enter Firm Company Name",
                          },
                        ]}
                      >
                        <Checkbox
                          value={partnerFirmMSMEFlagCheck}
                          checked={partnerFirmMSMEFlagCheck}
                          name="relativeOfAFSLEmployeeFlag"
                          onChange={() =>
                            setPartnerFirmMSMEFlagCheck(
                              !partnerFirmMSMEFlagCheck
                            )
                          }
                          onClick={hideSection}
                        >
                          Yes, relative of an employee of Avanse or its group
                          companies{" "}
                        </Checkbox>
                      </FormItem>
                    </Col>
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="inner-field-right"
                  >
                    <Col md={12} className="">
                      {partnerFirmMSMEFlagCheck ? (
                        <TextInput
                          maxLength={50}
                          title="Name of Employee"
                          onInput={(e) => {
                            if (e.target.value.trim() == "") {
                              e.target.value = e.target.value.trim();
                            }

                            if (e.target.value.trim() !== "") {
                              e.target.value = e.target.value.trimStart();
                            }
                          }}
                          name="relatedAFSLEmployeeName"
                          value={state.relatedAFSLEmployeeName}
                          onChange={onChangeTextHandler}
                          type="text"
                          validation={[
                            {
                              required: partnerFirmMSMEFlagCheck ? true : false,
                              message: "Enter Name of Employee",
                            },
                          ]}
                        />
                      ) : null}
                    </Col>
                  </Col>
                </Row>
              </Col>
            </Col>
          </Row>
          <div className="btnsection">
            <UiButton disabled={btnDisable} type="submit" title="Save" />
          </div>
          <hr></hr>
        </div>
      </Form>
    </div>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getTeamsData: (data) => dispatch(getTeamSideBarDetails(data)),
    saveTeamsDirectorDetailsAll: (data) =>
      dispatch(saveTeamsDirectorDetailsAll(data)),
    getData: (accessToken, parnterFirmID) =>
      dispatch(getTeamsDirectDetail(accessToken, parnterFirmID)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    data: state.teamsMasterData,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamDetailsDirectorPartnerDetails);
